import {
  Button, Grid, TextField, Box,
} from '@mui/material';
import React, { useState } from 'react';
import { UserStore } from '@gamiphy/loyalty-station-desktop/store/user';
import { ReferralsAnalytics } from '@gamiphy/loyalty-station-desktop/store/analytics';
import { useTranslation } from '@gamiphy/react-i18n';
import { isEmail } from '@gamiphy/utils/general';
import { useUserReferralsApi } from '@gamiphy/loyalty-station-desktop/hooks/apis';
import { AppStore } from '@gamiphy/loyalty-station-desktop/store/app';
import { ReferralDto } from '@coretava/api/events-service';

export type Props = {
  onChangeState: () => void,
  appReferral: ReferralDto,
}

const InviteFields: React.FC<Props> = ({ onChangeState, appReferral }) => {
  const [emailValue, setEmailValue] = useState('');
  const [emailSent, setEmailSent] = useState(false);
  const { t } = useTranslation();
  const userReferralsApi = useUserReferralsApi();

  const sendEmailInvitation = React.useCallback(async () => {
    const values = {
      name: UserStore.user ? `${UserStore.user.firstName ?? ''} ${UserStore.user.lastName ?? ''}` : '',
      email: emailValue,
    };
    await userReferralsApi.userReferralsControllerInvite(AppStore.app.id, appReferral.id, { name: values.name, email: values.email });
    ReferralsAnalytics.trackEmailSent();

    setEmailSent(true);
    setTimeout(() => {
      onChangeState();
    }, 4000);
  }, [AppStore.app, appReferral, emailValue]);

  return (
    <form onSubmit={(e) => {
      e.preventDefault();
      void sendEmailInvitation();
    }}
    >
      <Grid container spacing={1}>
        {emailSent && (
          <Box
            sx={{
              fontSize: '1.1rem',
              fontWeight: 600,
              position: 'absolute',
              opacity: 0.9,
              borderRadius: 20,
              backgroundColor: '#000000',
              p: 2,
              left: 0,
              right: 0,
              margin: '5rem',
              display: 'flex',
              top: '10px',
              justifyContent: 'center',
              alignItems: 'center',
              color: '#fff',
              textAlign: 'center',
            }}
          >
            {t('success.email', { defaultValue: 'Email was sent successfully' })}
          </Box>
        )}
        <Grid size={12}>
          <TextField
            name="email"
            type="email"
            variant="standard"
            placeholder={t('referral.exampleEmail', { defaultValue: 'friend@example.com' })}
            fullWidth
            InputProps={{
              disableUnderline: true,
              sx: {
                padding: 0,
                backgroundColor: 'transparent',
                fontSize: '1.2rem',
                fontWeight: 500,
                minHeight: '1.8rem',
                direction: 'ltr',
              },
            }}
            sx={{
              backgroundColor: 'transparent',
              border: 'solid 1px',
              p: 1,
              borderRadius: '0.6rem',
              mt: '1.5rem',
              maxWidth: '100%',
            }}
            value={emailValue}
            onChange={(e) => {
              setEmailValue(e.target.value);
            }}
          />
        </Grid>
        <Grid size={12}>
          <Button
            variant="contained"
            type="submit"
            disabled={!isEmail(emailValue)}
            color="primary"
            fullWidth
            sx={(theme) => ({
              boxShadow: '3px 3px 7px 0 rgba(0, 0, 0, 0.2)',
              border: 'solid 1px',
              borderColor: theme.palette.text.secondary,
              p: 1,
              m: '1rem 0',
              '& span': {
                fontSize: '1.2rem',
                fontWeight: 500,
                lineHeight: '1.5rem',
              },
            })}
          >
            {t('continue', 'Continue')}
          </Button>
        </Grid>
      </Grid>
    </form>
  );
};

export default InviteFields;
